export default function favoriteButton({ productId, initial }) {
    return {
        productId,
        isFavorite: initial,

        loading: false,
        error: null,

        animateAdd: false,
        animateRemove: false,

        async toggle() {
            if (this.loading) return;

            this.loading = true;
            this.error = null;

            try {
                const added = await Alpine.store('favorites')
                    .toggle(this.productId, 'favorite');

                if (typeof added !== 'boolean') return;

                this.isFavorite = added;

                if (added) {
                    this.animateAdd = false;
                    requestAnimationFrame(() => {
                        this.animateAdd = true;
                        setTimeout(() => this.animateAdd = false, 400);
                    });
                } else {
                    this.animateRemove = false;
                    requestAnimationFrame(() => {
                        this.animateRemove = true;
                        setTimeout(() => this.animateRemove = false, 400);
                    });
                }

            } catch (e) {
                console.error(e);
                this.error = 'Ошибка. Попробуйте позже.';
            } finally {
                this.loading = false;
            }
        }
    };
}
